'use strict'

const mapValues_ = require('lodash/mapValues')

const { createCmd, dispatchCmd } = require('redux-serial-effects')

const { setCurrentRecord } = require('./actions')

const TYPE = 'RECORDS'

const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'
const SET_FIELDS_IN_CURRENT_RECORD = 'SET_FIELDS_IN_CURRENT_RECORD'

const convertToFieldType = (fieldType, value) => {
  switch (fieldType) {
    case 'number': {
      return Number(value)
    }

    case 'boolean': {
      if (typeof value === 'string') {
        return value.toLowerCase() === 'true' || value.toLowerCase() === '1'
      }
      break
    }

    case 'text': {
      if (value != null && typeof value.toString === 'function') {
        return value.toString()
      }
      break
    }
  }

  return value
}

const ensureSchemaTypes = (getFieldType, record) =>
  mapValues_(record, (value, fieldName) =>
    convertToFieldType(getFieldType(fieldName), value)
  )

const provider = (recordStore, getFieldType) => ({
  type: TYPE,
  runner: cmd => {
    switch (cmd.cmdType) {
      case SET_CURRENT_INDEX:
        return recordStore().matchWith({
          Pending: () => {
            throw new Error('Record store service not ready yet')
          },
          Ready: async ({ instance }) => {
            const queryResult = await instance.getRecords(cmd.index, 1)

            return queryResult.matchWith({
              Empty: () => {
                return dispatchCmd(setCurrentRecord(null, null))
              },
              Results: ({ items }) => {
                return dispatchCmd(setCurrentRecord(items[0], cmd.index))
              }
            })
          }
        })

      case SET_FIELDS_IN_CURRENT_RECORD:
        const convertedFieldValues = ensureSchemaTypes(getFieldType, cmd.fields)

        return recordStore().matchWith({
          Pending: () => {},
          Ready: ({ instance }) =>
            instance
              .setFieldsValues(cmd.index, convertedFieldValues, cmd.source)
              .fold(
                e => {
                  throw e
                },
                _ => {}
              )
        })
    }
  }
})

const setCurrentIndexCmd = index =>
  createCmd(TYPE, true, {
    cmdType: SET_CURRENT_INDEX,
    index
  })

const setFieldsInCurrentRecordCmd = (fields, index, source) =>
  createCmd(TYPE, false, {
    cmdType: SET_FIELDS_IN_CURRENT_RECORD,
    fields,
    index,
    source
  })

module.exports.provider = provider
module.exports.setCurrentIndexCmd = setCurrentIndexCmd
module.exports.setFieldsInCurrentRecordCmd = setFieldsInCurrentRecordCmd



// WEBPACK FOOTER //
// ./records/provider.js